var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home"},[_c('span',{staticClass:"high-score"}),_c('br'),_c('br'),_c('br'),_c('img',{attrs:{"alt":"CountMyString.com","src":require("../assets/logo.png")}}),_c('StringOutput'),_c('StringInput')],1)}
var staticRenderFns = []

export { render, staticRenderFns }